export default __webpack_public_path__ + "images/assets/a5414b78c3b179a2ffffab77f2507592.svg";